// estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default {
  // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
  namespaced: true,

  state: {
    activar: false,
    tipo: null, // S = Correcto, E = Error, W = Advertencia
    mensaje: null,
    tiempo: 0, // 8000 = 8 seg , 0 es Indefinido,
  },
  // cambia los estados de las variables principales
  // de las variables princiaples

  mutations: {
    setActivar(state) {
      // pasa de verdadero a falso o visiversa
      state.activar = !state.activar;
    },

    setClose(state) {
      // limpiar objeto por defecto

      state.tiempo = 6000; // valor por defector
      state.mensaje = null;
      state.activar = false;
    },

    setTipo(state, tipo) {
      state.tipo = tipo;
    },

    setMensaje(state, mensaje) {
      state.mensaje = mensaje;
    },
    setTiempo(state, tiempo) {
      state.tiempo = tiempo;
    },

    setEnviar(state, datos) {
      //console.log(` Datos del para enviar: ${JSON.stringify(datos)}`)
      state.tipo = datos.tipo == null || datos.tipo == "" ? null : datos.tipo;
      state.mensaje =
        datos.mensaje == null || datos.mensaje == ""
          ? "Debe enviar un mensaje para Mostrar"
          : datos.mensaje;
      state.tiempo = datos.tiempo;
      state.activar = true;

      setTimeout(() => {
        state.activar = false;
      }, 3000);
    },

    setEnviarMens(state, datos) {
      //console.log(` Datos del para enviar: ${JSON.stringify(datos)}`)
      state.tipo = datos.tipo == null || datos.tipo == "" ? null : datos.tipo;
      state.mensaje =
        datos.mensaje == null || datos.mensaje == ""
          ? "Debe enviar un mensaje para Mostrar"
          : datos.mensaje;
      state.tiempo = datos.tiempo;
      state.activar = true;

      setTimeout(() => {
        state.activar = false;
      }, 3000);
    },
  },

  // crea una copía de los estado iniciales del store (state)
  getters: {},

  actions: {},
};

/*
    /////////////////////
    ////  Aplicando   ///
    ////////////////////
    import {mapMutations} from 'vuex'

    data: () => ({
            mensaje : {tipo:null, mensaje: null, tiempo:null},

    methods: {
            ...mapMutations('mensajeSis', ['setEnviar']),
            enviarMensaje() {
                this.setEnviar(this.mensaje)
            },
*/
